import { Component } from '@angular/core';
import { Table } from 'primeng/table';
import { BaseComponent } from 'src/app/core/base/base.component';
import esTranslation from 'src/assets/translations/es.json';
import { CommonAtcService } from './common.atc.service';

@Component({
  selector: 'ms-common-atc',
  templateUrl: './common.atc.component.html',
})
export class CommonAtcComponent extends BaseComponent {
  override readonly screen = {
    ...esTranslation,
    id: 'khuyana.common.atc',
    title: 'Sistema de Clasificación Anatómica, Terapéutica, Química (ATC)',
  };

  protected setScreen = true;
  showUploadDialog = false;
  atcTable?: Table;
  showExpandable = false;
  isCounter = false;
  isDoctor = false;
  isAdmin = false;

  constructor(protected service: CommonAtcService) {
    super();
  }

  onInit = () => {
    this.subscriptions.push(
      this.service.getUserInformation().subscribe((userInfo) => {
        if (userInfo.roles) {
          this.isAdmin = userInfo.roles.isAdmin ?? false;
          this.isCounter = userInfo.roles.isCounter ?? false;
          this.isDoctor = userInfo.roles.isDoctor ?? false;
        }
      })
    );
  };

  handleUploadSuccess = () => {
    this.atcTable?.reset();
  };
}
